import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import Firebase from './util/firebase'

Vue.config.productionTip = false

if (process.env.NODE_ENV === 'production') {
  //todo delete 
  console.log("Access Succeed");

  const firebase = new Firebase();
  firebase.initAnalytics();
}

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
